import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ScheduleInfo, ScheduleTimeType } from '../../types/tutor'

import { RootState } from '../store'

interface ScheduleSessionState {
  date?: string
  info: ScheduleInfo
  studentId?: number
  tutorId?: number
  time: ScheduleTimeType
}

const initialState: ScheduleSessionState = {
  date: undefined,
  info: {
    location: '',
  },
  studentId: undefined,
  tutorId: undefined,
  time: {
    startHours: 0,
    startMinutes: 0,
    endHours: 0,
    endMinutes: 0,
  },
}

const slice = createSlice({
  name: 'schedule-session',
  initialState,
  reducers: {
    setDate: (state, action: PayloadAction<string | undefined>) => ({ ...state, date: action.payload }),

    setInfo: (state, action: PayloadAction<{ name: string; value: string }>) => ({
      ...state,
      info: {
        ...state.info,
        [action.payload.name]: action.payload.value,
      },
    }),

    setStudent: (state, action: PayloadAction<number>) => ({ ...state, ...initialState, studentId: action.payload }),

    setTutor: (state, action: PayloadAction<number | undefined>) => ({
      ...state,
      tutorId: action.payload,
    }),

    setTime: (state, action: PayloadAction<{ name: string; value: number }>) => ({
      ...state,
      time: {
        ...state.time,
        [action.payload.name]: action.payload.value,
      },
    }),
  },
})

export const selectScheduledDate = (state: RootState): string | undefined => state.scheduleSession.date
export const selectScheduledInfo = (state: RootState): ScheduleInfo => state.scheduleSession.info
export const selectScheduledStudentId = (state: RootState): number | undefined => state.scheduleSession.studentId
export const selectScheduledTutorId = (state: RootState): number | undefined => state.scheduleSession.tutorId
export const selectScheduledTime = (state: RootState): ScheduleTimeType => state.scheduleSession.time

export const {
  setDate: setDateActionCreator,
  setInfo: setInfoActionCreator,
  setStudent: setStudentActionCreator,
  setTutor: setTutorActionCreator,
  setTime: setTimeActionCreator,
} = slice.actions

export default slice.reducer
